import { render, staticRenderFns } from "./addCase.vue?vue&type=template&id=55bcc95a"
import script from "./addCase.vue?vue&type=script&lang=js"
export * from "./addCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports